import React, {useState} from 'react'
import {css} from '@emotion/react'
import {Link} from 'gatsby'
import {createMarkup} from '../util/datoCmsDataFactory'
import {logDplWithExtensionParams, EVENTS} from '../util/dpl'
import Button from './button'
import {colors} from '../constants'

const SurveyUninstall = ({
    title,
    surveyCompleteTitle,
    surveyCompleteDescription,
    optionData,
    submitButtonText,
    reinstallButtonText,
    languageCode,
}) => {
    const [showSurveySubmitMsg, setShowSurveySubmitMsg] = useState(false)
    const [showSurveyError, setShowSurveyError] = useState(false)
    const [surveyData, setSurveyData] = useState({
        surveyReason: ``,
        surveyReasonText: ``,
    })

    const onSurveyInputChange = (e) => {
        const currentSelection = {}
        const {name, value} = e.target
        currentSelection[name] = value
        setSurveyData({
            ...surveyData,
            ...currentSelection,
        })
    }

    const onSurveySubmit = (event) => {
        event.preventDefault()
        let {surveyReason, surveyReasonText} = surveyData
        // dont log reason text if reason does not correspond with 'other' choice
        if (surveyReason !== '8') {
            surveyReasonText = ``
        } else if (surveyReasonText === '') {
            setShowSurveyError(true)
            return
        }
        setShowSurveyError(false)
        logDplWithExtensionParams(EVENTS.StartpageUninstallSurvey, {
            surveyReason,
            surveyReasonText,
        })
            .then(() => {
                setShowSurveySubmitMsg(true)
            })
            .catch((e) => {
                // eslint-disable-next-line no-console
                console.error(`can't submit form: ${e}`)
            })
    }

    const renderSurveySubmitMsg = () => {
        return (
            <div
                css={css`
                    min-height: calc(100vh - 750px);
                    h3 {
                        margin: 0 0 1rem;
                    }
                    p {
                        margin: 0 0 2rem;
                    }
                `}
            >
                <h3>{surveyCompleteTitle}</h3>
                <p>{surveyCompleteDescription}</p>
                <Link to={`/${languageCode}/protection`}>
                    <Button
                        text={reinstallButtonText}
                        onClick={() => {}}
                        overrideStyles={`
                            color: ${colors.whisperLight};
                            border: 1px solid ${colors.brandBlue};
                            border-radius: 10px;
                            padding: 16px 24px;
                            background: ${colors.brandBlue};
                            font-weight: 500;
                            margin-right: 2rem;
                            &:hover {
                                border: 1px solid ${colors.brandBlueLight};
                            }
                        `}
                    />
                </Link>
            </div>
        )
    }

    const renderForm = () => {
        return (
            <div
                css={css`
                    h2 {
                        margin: 0 0 2rem;
                        font-weight: 600;
                    }
                `}
            >
                <h2>{title}</h2>
                <form onSubmit={onSurveySubmit}>
                    {optionData.map(({title, description}, i) => {
                        const inputValue = i + 1 // options are valued 1 - optionData.length
                        const isSelected = String(inputValue) === surveyData.surveyReason
                        return (
                            <label
                                htmlFor={inputValue}
                                key={i}
                                css={css`
                                    display: flex;
                                    align-items: center;
                                    background: ${isSelected ? colors.brandBlueUltraLight : ''};
                                    border-radius: 4px;
                                    &:hover {
                                        cursor: pointer;
                                    }
                                    input {
                                        &:hover {
                                            cursor: pointer;
                                        }
                                    }
                                    padding: ${isSelected ? '1rem 2rem 1rem 1rem' : '1rem 2rem 0 1rem'};
                                    max-width: 660px;
                                    .option-text-main {
                                        font-weight: 400;
                                        margin: 0 0 0 1rem;
                                    }
                                    p {
                                        margin: 0 0 0 1rem;
                                    }
                                    textarea {
                                        max-width: 95%;
                                    }
                                    p,
                                    textarea {
                                        display: ${isSelected ? 'block' : 'none'};
                                    }
                                `}
                            >
                                <input
                                    type="radio"
                                    id={inputValue}
                                    value={inputValue}
                                    name="surveyReason"
                                    onChange={onSurveyInputChange}
                                    css={css`
                                        margin: 0;
                                    `}
                                />
                                <div
                                    css={css`
                                        width: 100%;
                                    `}
                                >
                                    <span className="option-text-main">{title}</span>
                                    <div dangerouslySetInnerHTML={createMarkup(description)} />
                                    {i === optionData.length - 1 && (
                                        <textarea
                                            onChange={onSurveyInputChange}
                                            defaultValue={surveyData.surveyReasonText}
                                            name="surveyReasonText"
                                            maxLength="256"
                                            css={css`
                                                appearance: none;
                                                width: 100%;
                                                color: #3b435c;
                                                border-radius: 4px;
                                                border: ${showSurveyError
                                                    ? '1px solid red'
                                                    : `1px solid ${colors.midnightLight}`};
                                                font-family: inherit;
                                                padding: 7px;
                                                max-width: 100%;
                                                box-shadow: 0 2px 4px ${colors.whisperDark};
                                                height: 3.875rem;
                                                background-color: ${colors.whisperLight};
                                                font-size: 0.875rem;
                                                margin: 0 0 0 1rem;
                                                &:focus {
                                                    border: 1px solid ${colors.brandBlueLight2};
                                                    outline: none;
                                                }
                                            `}
                                        />
                                    )}
                                </div>
                            </label>
                        )
                    })}
                    <div
                        css={css`
                            margin-top: 1.5rem;
                        `}
                    >
                        <Button text={submitButtonText} onClick={() => {}} />
                    </div>
                </form>
            </div>
        )
    }

    return <section className="survey">{showSurveySubmitMsg ? renderSurveySubmitMsg() : renderForm()}</section>
}

export default SurveyUninstall
